// src/components/UpdateNotifier.tsx
import { Button, notification } from "antd";
import React, { useEffect, useRef } from "react";

import { useRegisterSW } from "virtual:pwa-register/react";

const UpdateNotifier: React.FC = () => {
	const shownRef = useRef(false);
	const {
		needRefresh: [needRefresh, setNeedRefresh],
		updateServiceWorker,
	} = useRegisterSW({
		onRegisteredSW(swUrl, r) {
			console.log(`Service Worker at: ${swUrl}`);
			// @ts-expect-error just ignore
			if (reloadSW === "true") {
				r &&
					setInterval(() => {
						console.log("Checking for sw update");
						r.update();
					}, 20000);
			} else {
				// eslint-disable-next-line prefer-template
				console.log("SW Registered: " + r);
			}
		},
		onRegisterError(error) {
			console.log("SW registration error", error);
		},
	});

	useEffect(() => {
		if (needRefresh) {
			shownRef.current = true;
			const key = "pwa-update";

			notification.open({
				message: "New version available",
				description: "Click reload to update the app.",
				btn: (
					<Button
						type="primary"
						size="small"
						onClick={() => {
							updateServiceWorker();
							setNeedRefresh(false);
						}}
					>
						Reload
					</Button>
				),
				key,
				duration: 0,
				placement: "bottomRight",
			});
		}
	}, [needRefresh]);

	return null;
};

export default UpdateNotifier;
